import { Card, CardMedia, Typography, Box, CardActionArea } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Tags from "../Tags.js";
import { isNewArticle } from "../utils.js";

export default function FeaturedArticle(props = {}) {
  const {
    article,
    controls,
    fitImage,
    showInfo = true,
    enableTags,
    sx = {},
    sitePath
  } = props

  const navigate = useNavigate()
  const showNewIndicator = isNewArticle(article)
  const viewArticle = () => {
    if (article.newsWebUrl) {
      window.open(article.newsWebUrl, "_blank", "noopener,noreferrer");
    } else {
      if (article?.guid) {
        const path = sitePath ? `/${sitePath}/${article.guid}` : article.guid
        navigate(path)
      } else if (article?.webUrl) {
        window.open(article.webUrl, "_blank", "noopener,noreferrer")
      }
    }
  }

  return <Card
    sx={{ display: 'flex', ...sx }}
    className="featured-article"
  >
    <CardActionArea
      component='div'
      sx={{ display: 'flex' }}
    >
      <div className="article-click-container" style={{ position: 'relative' }} onClick={() => viewArticle(article)}>
        {showNewIndicator && <Box
          sx={{
            position: 'absolute',
            top: '5px',
            right: '5px',
            zIndex: 6,
            pointerEvents: 'none',
            borderRadius: '5px',
            px: '8px',
            py: '2px',
            backgroundColor: '#FFF4CC'
          }}
        >
          <Typography
            variant="body2"
            component="span"
            sx={{
              color: '#F40009',
              fontWeight: 700,
              letterSpacing: '.4px',
              lineHeight: 1.2
            }}
          >
            NEW
          </Typography>
        </Box>}
        <CardMedia component="div" sx={article?.image ? { backgroundImage: `url(${article?.image})` } : undefined} alt="Featured Article" className={"featured-image" + (fitImage ? "-fullbleed" : '')} />
        <CardMedia component="div" sx={article?.image ? { backgroundImage: `url(${article?.image})` } : undefined} alt="Featured Article" className="featured-image-blurred" />

        {showInfo && <div style={{ zIndex: 3 }}>
          <Box className="gradient-overlay">
            <Box className="article-info">
              <div>
                <Typography variant="h6" className="article-title">
                  {article?.title}
                </Typography>
                <Typography variant="caption" className="article-subtitle">
                  {article?.author} • {article?.date}
                </Typography>
              </div>

              <Tags
                tags={article?.tags || ""}
                clickable={enableTags}
                sx={{ marginTop: '4px' }}
                sitePath={sitePath}
              />
            </Box>
          </Box>


        </div>
        }

      </div>
      {controls}
    </CardActionArea>

  </Card>
}